module.exports = __webpack_public_path__ + "img/snm.fb919db4.svg";